import type { Provider } from '@angular/core';
import { inject, Injectable, TransferState } from '@angular/core';

import type { Environment } from './abstract-environment.service';
import { AEnvironmentService, APP_ENVIRONMENT_KEY } from './abstract-environment.service';
import { EnvironmentService } from './environment.service';

@Injectable({
	providedIn: 'root',
})
export class BrowserEnvironmentService extends AEnvironmentService {
	/**
	 * Our constructor
	 * @constructor
	 */
	constructor() {
		super(inject(TransferState));

		this._environment = this.transfer.get<Environment>(APP_ENVIRONMENT_KEY, {
			api: '',
			assets: '',
			apay: '',
			env: 'unknown',
			isProduction: false,
		});

		this.loaded.next(true);
	}
}

export function provideBrowserEnvironmentService(): Provider {
	return {
		provide: EnvironmentService,
		useClass: BrowserEnvironmentService,
	};
}
